import React from 'react';

import { StatusTip } from 'tea-component';
import styles from './index.less';

export default function App(props) {
  const { marginTop = '0', content = 'Loading...' } = props;
  return (
    <div className={styles.box}>
      <StatusTip
        status="loading"
        loadingText={content}
        style={{ marginTop: marginTop }}
      />
    </div>
  );
}
